import { RootState } from "../store";
export const selectRefreshTokenPlans = (state: RootState) => state.quote.refreshToken;
export const selectQuoteHash = (state: RootState) => state.quote.quoteHash;
export const selectQuote = (state: RootState) => state.quote.quote;
export const selectQuotePlans = (state: RootState) => state.quote.quote?.planes;
export const selectQuotePolicyNumber = (state: RootState) => state.quote.quote?.nroPoliza;
export const selectSelectedPlan = (state: RootState) => state.quote.selectedPlan;
export const selectErrorMessagePlans = (state: RootState) => state.quote.errorMessage;
export const selectSelectedCoverages = (state: RootState) => state.quote.selectedCoverages;